import React, {useState} from "react";
import {SubmitHandler, useForm} from "react-hook-form";
import {AddressResType} from "../../../../pages/customer/correspondent/detail/interface";
import {BasicSearchType} from "../../../../types/common/basic";
import {useReadAddressList} from "../../../../pages/customer/correspondent/detail/hooks";
import EmptyTableRow from "../../../../pages/common/EmptyTableRow";
import {ModalInnerConfirmType} from "../interface";
import {useModal} from "../../../../hooks";
import PaginationSub from "../../pagination/PaginationSub";

/**
 * 주소 검색 모달
 * @param props
 * @returns
 */
const SearchAddressInner = ({
                                confirmCallback,
                                cancelCallback,
                                modalDepth,
                                args
                            }: ModalInnerConfirmType<AddressResType>) => {
    const defaultSearchValue = {
        limit: 10,
        pageNo: 1,
        keywordType: "0",
        keyword: "",
        userId: args && args.userId ? args.userId : undefined,
    };

    const {handleModal, resetModal} = useModal();

    const [searchOption, setSearchOption] =
        useState<BasicSearchType & { userId: number | undefined }>(defaultSearchValue);

    const [selectItem, setSelectItem] = useState<AddressResType | null>(null);

    const {data} = useReadAddressList({searchData: {...searchOption, stateFlag: true}});

    const {register, handleSubmit} = useForm({
        defaultValues: searchOption,
    });

    const onSubmit: SubmitHandler<BasicSearchType & { userId: number | undefined }> = (submitData) => {
        setSearchOption(submitData);
    };

    const onClose = () => {
        resetModal(modalDepth);
    };

    const onConfirm = () => {
        if (selectItem?.new_addressid) {
            confirmCallback(selectItem);
            onClose();
        } else {
            handleModal({
                isOpen: true,
                contents: "주소를 선택해주세요.",
                type: "alert",
                depth: modalDepth + 1,
            });
        }
    };

    const onCancel = () => {
        onClose();
        cancelCallback && cancelCallback();
    };

    return (
        <>
            <form className="d-flex mb-15px" onSubmit={handleSubmit(onSubmit)}>
                <select className="form-select w-120px" {...register("keywordType")}>
                    <option value={"0"}>전체</option>
                    <option value={"1"}>이름</option>
                    <option value={"2"}>생성자</option>
                </select>
                <input
                    type="text"
                    className="form-control w-250px ms-5px h-34px"
                    {...register("keyword")}
                />
                <button type="submit" className="btn btn-info btn_search w-80px ms-5px">
                    <img
                        src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                        alt=""
                    />
                    조회
                </button>
            </form>

            <table className="table table-bordered my_table table_modal">
                <thead>
                <tr>
                    <th style={{width: "3%"}}></th>
                    <th style={{width: "19%"}}>이름</th>
                    <th style={{width: "8"}}>우편번호</th>
                    <th style={{width: "40%"}}>주소1</th>
                    <th style={{width: "16%"}}>주소2</th>
                    <th style={{width: "14%"}}>생성자</th>
                </tr>
                </thead>
                <tbody>
                {(data?.addressList ?? [])?.length === 0 ? (
                    <EmptyTableRow/>
                ) : (
                    (data?.addressList ?? [])?.map((item: AddressResType) => {
                        return (
                            <tr className={`clickable ${item.new_addressid === selectItem?.new_addressid ? "lightblue" : ""}`}
                                onClick={() => setSelectItem(item)}>
                                <td>
                                    <div className="checkbox_outer">
                                        <input type="radio"
                                               className="form-check-input"
                                               checked={item.new_addressid === selectItem?.new_addressid}
                                               onClick={() => setSelectItem(item)}/>
                                    </div>
                                </td>
                                <td className="text-center">{item?.newName ?? "-"}</td>
                                <td className="text-center">
                                    {item?.new_txt_postalcode ?? "-"}
                                </td>
                                <td className="text-center">{item?.new_txt_line1 ?? "-"}</td>
                                <td className="text-center">{item?.new_txt_line2 ?? "-"}</td>
                                <td className="text-center">{item?.createName ?? "-"}</td>
                            </tr>
                        );
                    })
                )}
                </tbody>
            </table>

            <PaginationSub
                totalCount={data?.totalCount ?? 0}
                currentPage={Number(searchOption.pageNo)}
                onChangeCallback={(i) =>
                    setSearchOption({...searchOption, pageNo: i})
                }
            />

            <div className="mt-3 d-flex align-items-center justify-content-end">
                <button
                    type="button"
                    className="btn btn-outline-primary w-100px h-38px my-0"
                    onClick={onCancel}
                >
                    취소
                </button>
                <button
                    type="button"
                    className="btn btn-dark w-100px h-38px my-0 ms-3"
                    onClick={onConfirm}
                >
                    선택
                </button>
            </div>
        </>
    );
};

export default SearchAddressInner;
